import { render, staticRenderFns } from "./ChiefBonus.vue?vue&type=template&id=12a946ee&scoped=true"
import script from "./ChiefBonus.vue?vue&type=script&lang=js"
export * from "./ChiefBonus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a946ee",
  null
  
)

export default component.exports